import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import useBreakpoint from '../../../hooks/useBreakpoint/index.js';
import styles from './searchWrapper.module.scss.js';
import { SearchInput } from '../SearchInput/index.js';
import { SearchMenu } from '../SearchMenu/index.js';

function SearchWrapper(_ref) {
  let {
    searchQuery,
    tracking,
    setShowOverlay,
    pageType,
    edition,
    trackClientContentAction,
    attachClientImpressionHandler,
    useUnitTracking,
    baseUrl,
    baseParamsString
  } = _ref;
  // determine whether or not to show search menu based on whether user has interacted with search input since page load
  const [searched, setSearched] = useState(false);
  const suggestionWrapRef = useRef(null);
  const inputWrapRef = useRef(null);
  const isDesktop = useBreakpoint('(min-width:1024px)');
  const handleClickOutside = event => {
    if (suggestionWrapRef && suggestionWrapRef.current && inputWrapRef && inputWrapRef.current) {
      if (!suggestionWrapRef.current.contains(event.target) && !inputWrapRef.current.contains(event.target)) {
        setSearched(false);
      }
    }
  };
  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
  }, []);
  useEffect(() => {
    if (searched) {
      setShowOverlay(false);
    }
  }, [searched]);
  useEffect(() => {
    if (isDesktop) {
      return;
    }
    if (searched) {
      document.body.classList.add(styles.noScroll);
    } else {
      document.body.classList.remove(styles.noScroll);
    }
  }, [searched, isDesktop]);
  return /*#__PURE__*/React.createElement("div", {
    className: `${styles.wrapper} ${pageType !== 'default' ? styles.categoryWrapper : ''}`
  }, /*#__PURE__*/React.createElement(SearchInput, {
    searchQuery: searchQuery,
    setSearched: setSearched,
    tracking: tracking,
    inputWrapRef: inputWrapRef,
    pageType: pageType,
    edition: edition,
    trackClientContentAction: trackClientContentAction,
    attachClientImpressionHandler: attachClientImpressionHandler,
    baseUrl: baseUrl,
    baseParamsString: baseParamsString
  }), /*#__PURE__*/React.createElement(SearchMenu, {
    searched: searched,
    tracking: tracking,
    suggestionWrapRef: suggestionWrapRef,
    edition: edition,
    pageType: pageType,
    useUnitTracking: useUnitTracking
  }));
}
SearchWrapper.propTypes = {
  query: PropTypes.string,
  searchUrl: PropTypes.string,
  tracking: PropTypes.object
};

export { SearchWrapper, SearchWrapper as default };
